module.exports = __webpack_public_path__ + "static/media/documents-action-plan.bf8ca93d.svg";